import React from "react";
import { Box } from "@chakra-ui/react";
import { MedalIconProps } from "../utils/types";

export const GaraazRankMedals = ({ rank, size = 20 }: MedalIconProps) => {
    if (rank < 1 || rank > 3) return null;

    const styles = {
        1: {
            bgColor: "gold",
            borderColor: "#fcbb07",
        },
        2: {
            bgColor: "silver",
            borderColor: "#a0a0a0",
        },
        3: {
            bgColor: "#CD7F32",
            borderColor: "#b87333",
        },
    };

    const { bgColor, borderColor } = styles[rank as 1 | 2 | 3];
    const ribbonWidth = Math.min(3, Math.floor(size * 0.15)); // 1% of size, minimum 3px
    const ribbonHeight = size; // Same as medal size
    const borderWidth = Math.min(3, Math.floor(size * 0.15)); // 1% of size, minimum 3px
    const fontSize = Math.floor(size * 0.55); // 1% of size, minimum 8px

    return (
        <Box position="relative" width={`${size}px`} height={`${size}px`}>
            <Box
                fontSize={`${fontSize}px`}
                fontWeight="extrabold"
                width={`${size}px`}
                height={`${size}px`}
                position="relative"
                display="flex"
                justifyContent="center"
                alignItems="center"
                bgColor={bgColor}
                color={"black"}
                border={`${borderWidth}px solid ${borderColor}`}
                borderRadius="50%"
                zIndex={2}
            >
                {rank}
            </Box>
            <Box position="absolute" top="0" left="0" width="100%" height="100%" zIndex={1}
                aria-label={`Medal for rank ${rank}`}
                role="img"
                _before={{
                    content: `''`,
                    position: "absolute",
                    top: "50%",
                    width: `${ribbonWidth}px`,
                    height: `${ribbonHeight}px`,
                    background: "#ff0000",
                    borderWidth: `0 ${ribbonWidth}px`,
                    borderColor: "#140037",
                    borderStyle: "solid",
                    clipPath: "polygon(0 0, 100% 0, 100% 100%, 50% 90%, 0% 100%)",
                    left: 0,
                    transform: `translateX(${Math.max(2, Math.floor(size * 0.2))}px) rotate(30deg)`,
                    zIndex: -1,
                }}
                _after={{
                    content: `''`,
                    position: "absolute",
                    top: "50%",
                    width: `${ribbonWidth}px`,
                    height: `${ribbonHeight}px`,
                    background: "#ff0000",
                    borderWidth: `0 ${ribbonWidth}px`,
                    borderColor: "#140037",
                    borderStyle: "solid",
                    clipPath: "polygon(0 0, 100% 0, 100% 100%, 50% 90%, 0% 100%)",
                    right: 0,
                    transform: `translateX(${-Math.max(2, Math.floor(size * 0.2))}px) rotate(-30deg)`,
                    zIndex: -1,
                }}></Box>
        </Box>
    );
};
        
export default GaraazRankMedals;

